import { render } from "./DisposalFeeInfo.vue?vue&type=template&id=9e8d9ba8"
import script from "./DisposalFeeInfo.vue?vue&type=script&lang=js"
export * from "./DisposalFeeInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__